import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d65306"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ds-badge__label"
}

import { computed } from 'vue';

interface Props {
  label?: string;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  icon?: string;
  outline?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSBadge',
  props: {
    label: { default: '' },
    variant: { default: 'primary' },
    size: { default: 'md' },
    icon: { default: '' },
    outline: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const variantColor = computed(() => {
  const colors: Record<string, string> = {
    primary: 'primary',
    secondary: 'secondary',
    success: 'positive',
    danger: 'negative',
    warning: 'warning',
    info: 'info',
  };
  return colors[props.variant];
});

const textColor = computed(() => {
  if (props.outline) return 'primary';
  return undefined;
});

const iconSize = computed(() => {
  const sizes: Record<string, string> = {
    sm: '12px',
    md: '14px',
    lg: '16px',
  };
  return sizes[props.size];
});

const badgeStyle = computed(() => ({
  fontSize: props.size === 'sm' ? '0.75rem' : props.size === 'lg' ? '1rem' : '0.875rem',
}));

const classes = computed(() => ({
  'ds-badge--sm': props.size === 'sm',
  'ds-badge--lg': props.size === 'lg',
}));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createBlock(_component_q_badge, {
    color: variantColor.value,
    "text-color": textColor.value,
    outline: _ctx.outline,
    rounded: "",
    class: _normalizeClass(classes.value),
    style: _normalizeStyle(badgeStyle.value)
  }, {
    default: _withCtx(() => [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: _ctx.icon,
            size: iconSize.value,
            class: _normalizeClass({ 'q-mr-xs': _ctx.label })
          }, null, 8, ["name", "size", "class"]))
        : _createCommentVNode("", true),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["color", "text-color", "outline", "class", "style"]))
}
}

})